import React from 'react';

import { array, bool, func, object, string } from 'prop-types';
import { propOr } from 'ramda';

import { useTranslate } from '../../translate/I18n';
import Plans from '../subscription/Plans';
import { nullFunction } from '../../utils/utils';

import Box from '../atoms/Box';
import Text from '../atoms/Text';
import SanitizedHTML from '../elements/SanitizedHTML';

const findPlanAttributeFromPlans = (plans, type, attr) => {
  const planFromPlans = (plans || []).find(({ type: currentType }) => currentType === type);
  return propOr(null, attr, planFromPlans);
};

const SubscriptionPlan = ({ hasCurrentSubscription, setType, setPrice, setCurrency, type, plans, onclickPlan }) => {
  const { t } = useTranslate(['common', 'subscription', 'pricing']);

  const getPriceBySubscription = type => {
    const yearlyPrice = findPlanAttributeFromPlans(plans, type, 'yearlyPrice');
    return yearlyPrice ? { pricePerMonth: yearlyPrice.perMonth, totalPrice: yearlyPrice.perYear } : {};
  };

  const handleSetPlan = ({ type, currency }) => {
    setType(type);
    setPrice(getPriceBySubscription(type));
    setCurrency(currency);
  };

  return (
    <>
      <Box
        display="grid"
        gridTemplateColumns={{ _: 'repeat(1, 1fr)', xl: 'repeat(4, 1fr)' }}
        maxWidth={{ _: '526px', xl: '100%' }}
        mx="auto"
        width="100%"
        gridGap={3}>
        <Plans
          list={plans}
          disabled={hasCurrentSubscription}
          active={type}
          onclickPlan={onclickPlan}
          setActive={hasCurrentSubscription ? nullFunction : handleSetPlan}
        />
      </Box>
      <Box mt={4} textAlign="center">
        <Text fontSize="16px" fontWeight="700">
          {t('subscription:needMoreMissionsOrTeamMembers')}
        </Text>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Box color="mainDark" mr="3px">
            <SanitizedHTML content={t('subscription:contactUs')} />
          </Box>

          {t('subscription:tailoredPlan')}
        </Box>
      </Box>
    </>
  );
};

SubscriptionPlan.propTypes = {
  hasCurrentSubscription: bool,
  handleSetPlan: func,
  selectLabel: string,
  setType: func,
  setPrice: func,
  setCurrency: func,
  type: string,
  current: object,
  plans: array,
  onclickPlan: func
};

SubscriptionPlan.defaultProps = {
  hasCurrentSubscription: false,
  handleSetPlan: nullFunction,
  setType: nullFunction,
  setPrice: nullFunction,
  setCurrency: nullFunction,
  type: null,
  current: null
};

export default SubscriptionPlan;
